import React, { useState, useEffect } from "react";

import { Row, Col } from "react-bootstrap";

import { useRouter } from "./../../../../../util/router";
import GYAxios from "../../../../../util/GYAxios";

import FormBodyKC from "./FormBodyKC";

const UsersFormKC = () => {
	const router = useRouter();
	const [existingUsers, setExistingUsers] = useState([]);

	const backBtnStyle = {
		cursor: "pointer",
		padding: "0px 5px",
		float: "right",
		fontSize: "2rem",
	};

	/**
	 * Fetch emails of existing GY users
	 */
	const fetchGYUsers = () => {
		const usersURI = `/users/filter?column=type&value=all`;

		GYAxios.get(usersURI).then((res) => {
			const users = !res.data.error ? res.data : [];
			setExistingUsers(users);
		});
	};

	useEffect(() => {
		fetchGYUsers();
	}, []);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col md="10">
						<h2 className="panel-title">GY Users</h2>
					</Col>
					<Col md="2">
						<span
							className="glyphicon glyphicon-chevron-left"
							style={backBtnStyle}
							onClick={() =>
								router.push(`/solar/administration/users/GY`)
							}
						></span>
					</Col>
				</Row>
			</div>
			<FormBodyKC existingUsers={existingUsers} />
		</div>
	);
};

export default UsersFormKC;
